import { createAction } from "@reduxjs/toolkit";

const GENERIC_STEP_ACTIONS = "genericStepActions";

export const genericStepActions = {
  initConfigCompleted: createAction(
    `${GENERIC_STEP_ACTIONS}/initConfigCompleted`,
  ),
};
